import ActiveHeartSvg from './active_heart.svg'
import HeartSvg from './heart.svg'
import Active_wishlistheart from './active_wishlistheart.svg'
import Wishlistheart from './wishlistheart.svg'
import DefaultCard from './default_card.png'
import DefaultDetailCard from './default_detail.png'
import Loading from './loading.png'
import Background from './background.jpg'
import BG from './bg-large.png'
import NewDefaultImg from './new-default.png'
import FilterIcon from './filter.png'
import EmptyCart from './empty.svg'
import WishlistInfo from './wishlist.svg'
import ArrowDown from './arrow-down.svg'
import PromotionTag from './promotion-tag.jpg'
import PromotionTag1 from './promotion-tag-1.jpg'
import Delivery from './delivery.png'
import LeftArrowBlack from './long-arrow-pointing-to-left.png'
import RightArrowBlack from './long-arrow-pointing-to-the-right.png'
import Facebook from './facebook.svg'
import userWhite from './user-white.png'
import userIconFill from './user-fill.svg'
import heartIconOutline from './heart-empty.png'
import fileIcon from './file-text.png'
import keyIcon from './key.png'
import logoutIcon from './logout.png'
import BagIconMobile from './shopping-bag-mobile.png'
import hotlineBlack from './headphone-black.png'
import userIcon from './user-outline.png'
import LocationSvg from './location.svg'
import Mail from './mail.svg'
import Telephone from './telephone.svg'
import hotLineIcon from './headphone.png'
import engImage from './eng.svg'
import myImage from './my.svg'
import help from './help.svg'
import MaskGpSvg from './mask_gp.svg'
import IconTickSvg from './icon_tick.svg'
import phone from './feather-phone.svg'
import mail from './feather-mail.svg'
import SearchIconLarge from './search-large.svg'
import map from './feather-map-pin.svg'
import scroll from './scroll.svg'
import accept from './accept.png'
import notfound from './notfound.png'

export default {
  userWhite,
  userIconFill,
  heartIconOutline,
  fileIcon,
  keyIcon,
  logoutIcon,
  BagIconMobile,
  hotlineBlack,
  userIcon,
  LocationSvg,
  Mail,
  Telephone,
  hotLineIcon,
  engImage,
  myImage,
  help,
  MaskGpSvg,
  IconTickSvg,
  phone,
  mail,
  SearchIconLarge,
  map,
  Facebook,
  LeftArrowBlack,
  RightArrowBlack,
  Delivery,
  PromotionTag1,
  PromotionTag,
  Loading,
  ActiveHeartSvg,
  HeartSvg,
  Active_wishlistheart,
  Wishlistheart,
  DefaultCard,
  DefaultDetailCard,
  Background,
  BG,
  NewDefaultImg,
  FilterIcon,
  EmptyCart,
  WishlistInfo,
  ArrowDown,
  scroll,
  accept,
  notfound
}